<template>
  <div class="size-descriptors" v-if="sizeDescriptors.length > 0">
    <template v-for="(descriptor, index) in sizes">
      <div class="size" v-if="descriptor.length" :key="index">
        {{ descriptor }}
        <span class="size-descriptor" v-if="index < sizeDescriptors.length">
          ({{sizeDescriptors[index]}})
        </span>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: "ProductSizeDisplay",
  props: {
    activeProduct: Object,
    productType: String,
  },
  data() {
    return {
      depthSizeProducts: ["Desk"],
    };
  },
  computed: {
    sizes() {
      // Hides first width for products that use the third width only
      const hiddenFirstWidths = [
        "Ottoman",
        "U-Shaped Sectional With Bumpers",
        "U-Shaped Sectional",
      ];
      const hiddenChaises = ["U-Shaped Sectional With Chaise", "Sectional With Chaise"];
      const primarySizeKeys = [
        "width_1",
        "width_2",
        "width_3",
        "chaise_width",
        "chaise_length",
      ];
      const chaiseKeys = ["chaise_width", "chaise_length"];
      const secondarySizeKeys = ["depth", "depth_size"];
      const sizes = [];
      if ('Sectional With Chaise' === this.productType && this.activeProduct.orientation == 'Chaise On Right') {
         sizes.push(`${this.activeProduct['width_2']}"`)
         sizes.push(`${this.activeProduct['width_1']}"`)
      } else {
        primarySizeKeys.forEach((key) => {
        if (this.activeProduct[key]) {
          if (hiddenFirstWidths.includes(this.productType)) {
            // Ignoring first width for these
            if (key !== "width_1") {
              if (hiddenChaises.includes(this.productType)) {
                if (!chaiseKeys.includes(key)) {
                  sizes.push(`${this.activeProduct[key]}"`);
                }
              } else {
                sizes.push(`${this.activeProduct[key]}"`);
              }
            }
          } else if (hiddenChaises.includes(this.productType)) {
            if (!chaiseKeys.includes(key)) {
              sizes.push(`${this.activeProduct[key]}"`);
            }
          } else {
            sizes.push(`${this.activeProduct[key]}"`);
          }
        }
      });
      secondarySizeKeys.forEach((key) => {
        if (this.activeProduct[key]) {
          const secondaryKeyVal = this.processSecondaryKeys(
            key,
            this.activeProduct[key]
          );
          if (secondaryKeyVal) {
            sizes.push(secondaryKeyVal);
          }
        }
      });
      }
      return sizes;
    },
    sizeDescriptors() {
      if (['Sofa', 'Chair', 'Loveseat', 'Sofa with Bumper', 'Corner'].includes(this.productType)) {
        return ['Wide']
      } else if (['U-Shaped Sectional', 'U-Shaped Sectional With Bumpers'].includes(this.productType)) {
        return ['Wide', "Side"]
      } else if (['Double Chaise Sectional','Sofa with Chaise'].includes(this.productType)) {
        return ['Width', "Chaise Width", "Chaise Length"]
      } else if ('Sectional' === this.productType) {
        return ['Sofa Side', "Corner Side"]
      } else if ('Sectional with Bumper' === this.productType) {
        return ['Sofa Side', "Bumper Side"]
      } else if ('Chaise' === this.productType) {
        return ['Width', "Length"]
      } else if ('Desk' === this.productType) {
        return ['Width', "Depth"]
      } else if ('Sofa Bed' === this.productType) {
        return ['Width']
      } else if ('Sectional With Chaise' === this.productType) {
        return ['Total Width', "Corner Side"]
      } 
      return []
    }
  },
  methods: {
    processSecondaryKeys(key, value) {
      if (key === "depth") {
        if (value === "Standard") return "";
        else {
          return value
            .split(" ")
            .map((part) => part[0].toUpperCase())
            .join("");
        }
      }
      if (key === "depth_size") {
        if (this.depthSizeProducts.includes(this.productType)) {
          return `${this.activeProduct[key]}"`;
        }
        return "";
      }
      return value;
    },
  },
};
</script>
<style scoped>
.size {
  color: #3a3830;
  margin-right: 5px;
  font-size: 16px;
  font-weight: 500;
}
.size-descriptor {
  font-size: 12px;
  font-weight: 400;
}
.size-descriptors {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}
</style>
>
